import { HStack, Image, Tooltip } from '@chakra-ui/react';
import { motion, useReducedMotion } from 'framer-motion';
import { dimUntilHoverControl } from '@/modules/content/loop/model/loopChrome';

type Props = {
  iconSrc: string;
  label: string;
  active?: boolean;
  onClick: () => void;
};

// A single circular action in the loop's rail. Rests dimmed with the rest of the chrome
// and lifts on its own hover, so the highlight tracks exactly what is being pointed at.
// When it turns active (a like / save), the icon gives a small pop for tactile feedback.
const RailButton = ({ iconSrc, label, active, onClick }: Props) => {
  const reduceMotion = useReducedMotion();

  return (
    <Tooltip label={label} placement="right" hasArrow>
      <HStack
        as="button"
        type="button"
        onClick={onClick}
        aria-label={label}
        aria-pressed={active}
        justify="center"
        width="42px"
        height="42px"
        borderRadius="full"
        backgroundColor="white"
        borderWidth="2px"
        borderColor={active ? 'primary.500' : 'transparent'}
        boxShadow="0px 4px 14px rgba(14, 0, 98, 0.10)"
        {...dimUntilHoverControl}
        transition="all 0.15s ease"
        _hover={{ opacity: 1, transform: 'translateY(-2px)', borderColor: 'primary.500' }}
        _focusVisible={{ opacity: 1 }}
        _active={{ transform: 'scale(0.94)' }}
      >
        <motion.span
          style={{ display: 'inline-flex' }}
          animate={reduceMotion ? undefined : { scale: active ? [1, 1.35, 1] : 1 }}
          transition={{ duration: 0.32, ease: 'easeOut' }}
        >
          <Image src={iconSrc} alt="" width="19px" height="19px" objectFit="contain" />
        </motion.span>
      </HStack>
    </Tooltip>
  );
};

export default RailButton;
